(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.introSlider = {
        attach: function (context) {
            const slider = once('intro-slider', '.intro-features .swiper', context)[0];
            if (!slider) return;

            if (typeof Swiper === 'undefined') {
                console.warn('Swiper library not loaded');
                return;
            }

            const options = {
                slidesPerView: 1.7,
                spaceBetween: 24,
                loop: true,
                breakpoints: {
                    576: {
                        slidesPerView: 1.85,
                    },
                    992: {
                        slidesPerView: 1.5,
                    },
                    1200: {
                        loop: false,
                        slidesPerView: 3,
                        spaceBetween: 0,
                    }
                },
                on: {
                    breakpoint: function (swiper) {
                        if (window.innerWidth >= 1200) {
                            swiper.disable();
                            swiper.el.classList.add('swiper-disabled');
                        } else {
                            swiper.enable();
                            swiper.el.classList.remove('swiper-disabled');
                            swiper.update();
                        }
                    }
                }
            };

            try {
                const swiperInstance = new Swiper(slider, options);
                slider.classList.add('is-swiper-active');

                if (window.innerWidth >= 1200) {
                    swiperInstance.disable();
                    slider.classList.add('swiper-disabled');
                }
            } catch (error) {
                console.error('Failed to initialize Swiper:', error);
            }
        }
    };

})(Drupal, once);